/**
 * Bond Custody-Provider Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_trading_platform/src/master/application/Exporo/Trading/src/Datatypes/Enums/Bonds/CustodyProvider.php
 */

const AssetProvidersEnum = Object.assign({
  BAADERBANK: 'baaderbank',
  UPVEST: 'upvest',
  TANGANY: 'tangany',
});

Object.freeze(AssetProvidersEnum);

export default AssetProvidersEnum;



// WEBPACK FOOTER //
// ./src/enum/trades/AssetProviders.js